export const METHODS_ACTIONS = {
    GET: 'GET_EXTRACTION_METHODS',
    FIND: 'FIND_EXTRACTION_METHODS',
    CHANGE_STATUS: 'CHANGE_STATUS_EXTRACTION_METHODS',
    SUCCESS: 'SUCCESS_EXTRACTION_METHODS',
    ERROR: 'ERROR_EXTRACTION_METHODS',
    CLEAN: 'CLEAN_EXTRACTION_METHODS',
}